export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_q04_a.ea3daf41.png";